<template>
  <div class="px-4 w-full lg:w-1/3">
    <div class="border border-grey-light">
      <div class="w-full flex text-sm p-4 bg-grey-lighter border-t-4 border-primary">
        <strong class="h-6">Your Order Summary</strong>
      </div>
      <div class="pt-4 px-4 leading-normal">
        <table v-if="registrants.length > 0" class="w-full">
          <tbody v-for="(registrant, i) in registrants" :key="i">
            <tr><td colspan="2" class="align-top text-sm font-bold pt-3">{{ registrant.first_name + ' ' + registrant.last_name }}</td></tr>
            <tr>
              <td class="align-bottom text-left text-sm">Price</td>
              <td class="align-bottom text-right text-sm">1 x {{ ticket.price | gbp }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="registrants.length > 0" class="px-4 pt-6 text-sm">
        <div v-if="ticket.is_free" class="pb-3">Free Entry</div>
        <div v-if="discountApplied" class="pb-3">Discount Applied
          <div v-if="ticket.earlybird_discount_amount"  class="py-2">Amount Saved: {{ registrants.length * ticket.earlybird_discount_amount | gbp }}</div>
          <div v-if="ticket.earlybird_discount_percentage"  class="py-2">Discount Percentage: {{ ticket.earlybird_discount_percentage }}%</div>
          <div v-if="appliedDiscountRules">
            <div  class="pb-3" v-for="(rule,i) in appliedDiscountRules" :key="i">{{ rule.name }}</div>
          </div>
        </div>
      </div>
      <div class="px-4 pt-4">
        <h4 class="block text-sm pb-3">Total</h4>
        <table class="w-full mb-4">
          <tbody>
            <tr>
              <td class="align-top text-sm pb-2">
                Subtotal
              </td>
              <td class="align-top text-right text-sm pb-2">{{ subtotal | gbp }}</td>
            </tr>
            <tr v-if="vat !== 0">
              <td class="align-top text-sm pb-3">
                VAT (20%)
              </td>
              <td class="align-top text-right text-sm pb-3">{{ vat | gbp }}</td>
            </tr>
            <tr>
              <td class="align-top text-sm font-bold">
                Total
              </td>
              <td class="align-top text-right text-sm font-bold">{{ total | gbp }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="stage === 3" class="w-full mb-6">
        <div v-if="ticket.min_order && registrants.length < ticket.min_order" class="text-red-dark p-4">
          Please book minimun {{ ticket.min_order }} ticket(s)
        </div>
        <div v-else-if="ticket.max_order && registrants.length > ticket.max_order" class="text-red-dark p-4">
          Please book maximun {{ ticket.max_order }} ticket(s)
        </div>
        <div v-else>
          <hr class="border-b border-grey-light">
          <div class="px-4">
            <p class="mt-4 mb-6 text-xs leading-normal">Before you place your order please check that all the information for each attendee is correct, including email address and dietary requirements. </p>
            <div  v-if="registrants.length > 0">
              <div v-if="ticket.payment_type_id == 2">
                <h2 class="font-bold text-base mb-6">Please select a payment type</h2>
                <p class="flex items-center justify-between text-sm mb-4">
                  <input type="radio" id="type_invoice" v-model="order_payment_type_id" value="0" />
                  <span for="type_invoice" class="ml-4">Invoice: Please invoice me ({{ office.name }}) directly for this order, by adding it to my monthly invoice.</span>
                </p>
                <p class="flex items-center justify-between text-sm mb-4">
                  <input type="radio" id="type_upfront" v-model="order_payment_type_id" value="1" />
                  <span for="type_upfront" class="ml-4">Up-Front: Credit or Debit card payment, to be taken before order is placed.</span>
                </p>
              </div>
              <button class="w-full py-4 text-white text-xs uppercase bg-primary hover:bg-black" @click="$emit('submit', order_payment_type_id)">Make Payment</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Table from '../../components/Table.vue'
import { mapState } from 'vuex'
export default {
  components: { Table },
  props: ['stage', 'ticket', 'registrants', 'subtotal', 'vat', 'total'],
  data () {
    return {
      loaded: true,
      order_payment_type_id: null
    }
  },
  computed: {
    ...mapState({ office: state => state.selectedOffice }),
    discountApplied: function () {
      if (this.ticket.earlybird_discount_amount || this.ticket.earlybird_discount_percentage) {
        if (this.ticket.earlybird_discount_deadline) {
          let time = new Date(this.ticket.earlybird_discount_deadline).getTime()
          return Date.now() <= time
        }
        return true
      }
      if (this.ticket.discount_rules) {
        return true
      }
      return false
    },
    appliedDiscountRules: function () {
      let appliedDiscountRules = []
      if (this.ticket.discount_rules) {
        if (this.ticket.is_free) {
          return []
        }

        let ticketNum = this.registrants.length
        for (var index in this.ticket.discount_rules) {
          let discountRule = this.ticket.discount_rules[index]
          if (ticketNum >= discountRule.base_number) {
            appliedDiscountRules.push(discountRule)
          }
        }
        return appliedDiscountRules
      }

      return []
    }
  },
  created () {
    this.order_payment_type_id = this.ticket.payment_type_id !== 2 ? this.ticket.payment_type_id : null
  }
}
</script>
